import { ICellRendererParams } from 'ag-grid-community';
import { formatAmount } from 'src/utils/commonUtils';
import styles from './TeamLead.module.scss';
import { Tooltip, TooltipContent, TooltipTrigger } from '@cp/src/components/TooltipV2/TooltipV2';
import EllipsisText from '@cp/src/components/EllipsisText';
import Button from '@navi/web-ui/lib/primitives/Button/Button';
import { useNavigate } from 'react-router-dom';
import APP_ROUTES from '@cp/src/layout/Routes';

export const TIMELINES_COL_DEFS = () => {
  const navigate = useNavigate();
  return [
    {
      field: 'name',
      headerName: 'name',
      minWidth: 180,
      cellRenderer: (params: ICellRendererParams) => {
        return (
          <Tooltip placement="top" hiddenPadding={0} hideStrategy="referenceHidden">
            <TooltipTrigger tooltipTriggerClassName="tooltipTriggerWrapper">
              <EllipsisText text={params.value} />
            </TooltipTrigger>
            <TooltipContent className="tooltipWrapper">{params.value}</TooltipContent>
          </Tooltip>
        );
      }
    },
    {
      field: 'description',
      headerName: 'description',
      serverSortable: true,
      // width: 180,
      cellRenderer: (params: ICellRendererParams) => {
        return <EllipsisText text={params.value} />;
      }
    },
    {
      field: 'productCodes',
      headerName: 'productCodes',
      serverSortable: true,
      wrapHeaderText: true,
      // width: 180,
      cellRenderer: (params: ICellRendererParams) => {
        return <EllipsisText text={params.value} />;
      }
    },
    {
      field: 'status',
      headerName: 'status',
      serverSortable: true,
      wrapHeaderText: true,
      // width: 180,
      cellRenderer: (params: ICellRendererParams) => {
        return <EllipsisText text={params.value} />;
      }
    },
    {
      field: 'updatedAt',
      headerName: 'updatedAt',
      serverSortable: true,
      wrapHeaderText: true,
      // width: 180,
      cellRenderer: (params: ICellRendererParams) => {
        return <EllipsisText text={params.value} />;
      }
    },
    {
      field: 'anchorDate',
      headerName: 'anchorDate',
      serverSortable: true,
      wrapHeaderText: true,
      // width: 180,
      cellRenderer: (params: ICellRendererParams) => {
        return <EllipsisText text={params.value} />;
      }
    },
    {
      field: '',
      headerName: '',
      // width: 200,
      cellRenderer: (params: ICellRendererParams) => {
        const toViewTimelines = APP_ROUTES.PARAMOUNT_VIEW_TIMELINE;

        return (
          <Button
            variant="primary"
            size="small"
            onClick={() => navigate(`${toViewTimelines.path}?timelineName=${params?.data?.name}`)}
          >
            View Timeline Details
          </Button>
        );
      }
    }
  ];
};
